// extracted by mini-css-extract-plugin
module.exports = {"container":"math_container__QkzTR","inlineContainer":"math_inlineContainer__QxxXA","input":"math_input__l7FCH","preview":"math_preview__XoewH"};